class Recaptcha {
    constructor() {
    }
    domInjection() {
        let newScriptElement = document.createElement("script");

        newScriptElement.src = "https://www.google.com/recaptcha/api.js";
        newScriptElement.type='text/javascript';
        newScriptElement.async = true;
        newScriptElement.defer = true;

        this.appendElementToBody(newScriptElement);
    }
    appendElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
}

export default Recaptcha;